import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const HeroSection = () => {
  const measureRef = useRef(null);
  const [rowWidth, setRowWidth] = useState(null);

  useEffect(() => {
    const measure = () => {
      if (measureRef.current) {
        const w = measureRef.current.getBoundingClientRect().width;
        setRowWidth(w);
      }
    };
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  return (
    <section className="hero-section">
      {/* Hidden measuring span — gets the true intrinsic text width of line 1 */}
      <span
        ref={measureRef}
        aria-hidden="true"
        style={{
          position: "absolute",
          visibility: "hidden",
          whiteSpace: "nowrap",
          fontFamily: "inherit",
          fontSize: "clamp(3rem, 5.5vw, 5rem)",
          fontWeight: 800,
          letterSpacing: "-0.03em",
          pointerEvents: "none",
        }}
      >
        Nanopore basecalling without
      </span>

      <div className="hero-text-wrapper">
        <div className="container">
          <div className="hero-container">

            <h1 className="hero-headline">
              <span style={{ display: "block" }}>Nanopore basecalling without</span>
              <span style={{ display: "block" }}>the hardware or hardwork</span>
            </h1>

            <div
              className="hero-bottom-row"
              style={rowWidth ? { width: rowWidth, maxWidth: "100%" } : {}}
            >
              <div className="hero-sub-block">
                <p className="hero-sub">
                  FeraBio combines cloud basecalling, secure data storage, and built-in sharing so teams can run analysis faster without managing local GPU infrastructure.
                </p>
              </div>

              <div className="hero-cta-group">
                <Link className="btn-primary-cta" to="/waitlist">
                  Join Waitlist
                </Link>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
